import { Component } from '@angular/core';
import { SbSupportTextBlockComponent } from '@app/+modals/sb-support/blocks/text/sb-support-text-block.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AnchorButtonComponent } from '@sb/ui/button';

@Component({
  selector: 'sb-remote-support-widget',
  templateUrl: './sb-remote-support-widget.component.html',
  imports: [SbSupportTextBlockComponent, TranslatePipe, AnchorButtonComponent],
})
export class SbRemoteSupportWidgetComponent {}
